import React from 'react';
import pt from 'prop-types';
import {getPageData} from '../../sources/CmsSource';
import {useGetPageData} from '../../actions/CmsActions';
import BlankContainer from './Blank.container';
import {extractSlugLocale} from '@epic-core/localization';
import {useLocation} from 'react-router';

const BlankView = () => {
    const location = useLocation();
    const pathname = location.pathname || '';
    const {pageSlug} = extractSlugLocale(pathname);
    const pageData = useGetPageData({cmsUrlPattern: pageSlug});
    return <BlankContainer pageData={pageData} />;
};

BlankView.propTypes = {
    location: pt.object
};

BlankView.getInitialProps = async (match, {locale}, requestedUrl) => {
    const {pageSlug} = extractSlugLocale(requestedUrl);

    const skip = ['/error-500', '/error-404', '/page-not-found', '/unexpectedError'];
    if (skip.indexOf(pageSlug) !== -1) {
        return {};
    }

    const rawPageData = await getPageData(pageSlug);

    //must match structure of StoreProvider
    return {
        cms: {
            [pageSlug]: rawPageData
        }
    };
};

export default BlankView;
